/* Настройки страницы для движка шаблона в серверном режиме (engine-kit, план движков §5.5): поверх ui шаблона (BotCore.uiDefaults и init страницы)
   снимается всё, что в production не должно работать само: знак заказа страницы (ui.job — знак публикует кадр, use-order-badge), списание
   (ui.spend), имитации записи и быстрые этапы (sim, fast), переход в другой экран студии (openApp — перенос итога делает SV). Баланс —
   только для решения «не хватает» подвала (FOOT.poor: ui.balance() < price()), на странице его не показывают (I3).
   tx — словарь профиля для своих строк ядра (текстовый шов BotCore.tx, шаг 7 и решение владельца Q3): подвал, лист «Не хватает Circle»
   и хвост BotRun берут его из ui; без tx (демо, прочие экраны) ядро показывает строки шаблона как есть. */
import { uiFormat } from '../../../i18n';
import type { OrderSnapshot } from './order-service';

/** Свойства, которые серверный режим ставит сам: у base они свои (функции страницы, флаги имитаций), поэтому из base они уходят */
type Served = 'job' | 'spend' | 'sim' | 'fast' | 'openApp' | 'balance' | 'tx';
export type ServerUi<U> = Omit<U, Served> & {
  job: null;
  spend: null;
  sim: false;
  fast: false;
  openApp: null;
  balance(): number;
  tx(template: string, ...values: unknown[]): string;
};

/** Новый объект ui: свойства base переносятся описателями (геттеры страницы остаются живыми), затем серверные значения */
export function serverUi<U extends object>(base: U, o: { poorBalance(): number }): ServerUi<U> {
  const ui = Object.create(Object.getPrototypeOf(base), Object.getOwnPropertyDescriptors(base)) as Record<string, unknown>;
  for (const key of ['job', 'spend', 'openApp'] as const) Object.defineProperty(ui, key, { value: null, writable: true, enumerable: true, configurable: true });
  for (const key of ['sim', 'fast'] as const) Object.defineProperty(ui, key, { value: false, writable: true, enumerable: true, configurable: true });
  Object.defineProperty(ui, 'balance', { value: () => o.poorBalance(), writable: true, enumerable: true, configurable: true });
  /* язык берётся в момент показа: смена языка профиля не требует нового ui */
  Object.defineProperty(ui, 'tx', { value: (template: string, ...values: unknown[]) => uiFormat(template, ...values), writable: true, enumerable: true, configurable: true });
  return ui as ServerUi<U>;
}

/** Баланс для «не хватает Circle»: остаток родной кнопки (GET /app/balance, circleBalance), а там, где проверять нечего, — бесконечность
    (подвал не уходит в «Пополнить»): остаток неизвестен, работа бесплатна (form.chargeable === false), ждёт проверки прежняя заявка
    или длина записи ещё не известна */
export function poorBalance(s: Pick<OrderSnapshot, 'balance' | 'form' | 'intent'>, durationKnown: boolean): number {
  if (s.balance === null || !Number.isFinite(s.balance) || s.form?.chargeable === false || s.intent || !durationKnown) return Infinity;
  return s.balance;
}
